/**
 * @file analytics.ts
 * @description Migration placeholder for analytics functions.
 * Original Firebase Analytics implementation moved to _archive/firebase.
 * This stub provides noop functions to prevent import errors.
 */

/**
 * Analytics event parameters
 */
export type AnalyticsEventParams = Record<string, any>;

/**
 * No-op log event function
 * @deprecated Firebase Analytics removed. Implement alternative analytics if needed.
 * @param eventName - Name of the event to log
 * @param eventParams - Event parameters
 * @param options - Additional options
 */
export const logEvent = (
  eventName: string,
  eventParams?: any,
  options?: any
): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics - Noop]', eventName, eventParams, options);
  }
};

/**
 * No-op set user properties function
 * @deprecated Firebase Analytics removed. Implement alternative analytics if needed.
 * @param properties - User properties to set
 */
export const setUserProperties = (properties: Record<string, any>): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics - Noop] setUserProperties', properties);
  }
};

/**
 * No-op set user ID function
 * @deprecated Firebase Analytics removed. Implement alternative analytics if needed.
 * @param userId - User ID to set
 */
export const setUserId = (userId: string | null): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics - Noop] setUserId', userId);
  }
};

/**
 * No-op screen view function
 * @deprecated Firebase Analytics removed. Implement alternative analytics if needed.
 * @param screenName - Name of the screen
 */
export const logScreenView = (screenName: string): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics - Noop] logScreenView', screenName);
  }
};

/**
 * Analytics object with logEvent method
 * @deprecated Firebase Analytics removed. Implement alternative analytics if needed.
 */
export const analytics = {
  logEvent,
  setUserProperties,
  setUserId,
  logScreenView,
};

export default analytics;
